import React from 'react';

interface ExpertReview {
  editorName: string;
  editorTitle: string;
  reviewQuote: string;
  editorAbout?: string;
  editorImageSrc?: string;
}

interface EditorialStatementProps {
  expertReviews: ExpertReview[];
  isDarkMode: boolean;
}

const EditorialStatement: React.FC<EditorialStatementProps> = ({ expertReviews, isDarkMode }) => {
  if (!expertReviews || expertReviews.length === 0) {
    return null;
  }

  return (
    <div className="mt-16">
      {expertReviews.map((review, index) => (
        <div key={index} className={`rounded-lg p-6 ${
          isDarkMode ? 'bg-black-custom text-theme-primary-dark' : 'bg-black-100 text-theme-primary-light'
        }`}>
          {/* Compact Horizontal Layout */}
          <div className="flex items-start gap-4 mb-4">
            
            
            {/* Name and Title */}
            <div>
              <h3 className={`portrait-text-app text-2xl font-regular  ${
                isDarkMode ? 'text-theme-primary-dark' : 'text-theme-primary-light'
              }`}>
                {review.editorName}
              </h3>
            </div>
          </div>

          {/* Quote */}
          <blockquote className={`text-base italic leading-relaxed ${
            isDarkMode ? 'text-black-300' : 'text-black-700'
          }`}>
            "{review.reviewQuote}"
          </blockquote>

          {/* About Section */}
          {review.editorAbout && (
            <div className="mt-6">
              <div className={`text-sm leading-relaxed ${
                isDarkMode ? 'text-black-300' : 'text-black-700'
              }`}>
                <p>
                  <span className="font-semibold">About Editor:</span> {review.editorAbout}
                </p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default EditorialStatement;
